// NOTE: styled(Document)/styled(Page) wrappers used to live here but that
// pulled react-pdf (~1.5 MB + pdf.worker) into the main webpack bundle
// eagerly. The PDF preview is now rendered via a lazy-loaded module at
// ./ResumePdfRenderer so react-pdf is split into its own chunk.
import styled from 'styled-components'

export const Container = styled.div`
	padding: 1rem 0.5rem;
	background-color: #F3F6F7FF;
	height: calc(100% - 78px);
	overflow-y: auto;
`

export const TextContainer = styled.div`
	padding: 10px 35px;
`
